import React, { useState, useEffect } from 'react';
import SolicitationService from "../../../services/SolicitationService/SolicitationService";
import "./index.css";

interface Props {
    row: any,
    type: string
}

const StatusColorDisplay: React.FC<Props> = (props) => {
    const solicitationService = new SolicitationService(props);
    const [label, setLabel] = useState<string>("");
    const [statusIdLocal, setStatusIdLocal] = useState<number>(1);

    useEffect(() => {
        if (props.row.idStatus && solicitationService.statusList) {
            let statusId_ = props.row.idStatus;

            if (props.type === "work") {
                if (props.row.idStatus == 7) {
                    if (props.row.approved == 1) {
                        statusId_ = 15;
                    }
                    else if (props.row.approved == 0) {
                        statusId_ = 16;
                    }
                }
            }

            setStatusIdLocal(statusId_);

            var arr = (props.type === "work")
                ? solicitationService.workStatus.find(x => x && x.id === statusId_)
                : solicitationService.statusList.find(x => x && x.value === statusId_.toString());

            setLabel((arr?.label) ? arr.label : "");
        }
    }, [props.row])

    // const statusColor = (idStatus: number) => {
    //     switch (idStatus) {
    //         case 1: return "#0975D9";
    //         case 2: return "#FCEBC1";
    //         case 3: return "#FCEBC1";
    //         case 4: return "#2B304F";
    //         case 5: return "#DCDEE9";
    //         case 6: return "#F9D0D0";
    //         case 7: return "#DBF4E5";
    //         case 8: return "#DBF4E5";
    //         case 9: return "#E2F1FF";
    //         case 10: return "#BE8E12";
    //         case 11: return "#DCDEE9";
    //         case 12: return "#DCDEE9";
    //         case 13: return "#DCDEE9";
    //         case 14: return "#BE8E12";

    //         default: return "rgb(226, 230, 243)";
    //     }
    // }

    const statusColors: Record<number, string> = {
        1: "#0975D9",
        2: "#FCEBC1",
        3: "#FCEBC1",
        4: "#2B304F",
        5: "#DCDEE9",
        6: "#F9D0D0",
        7: "#DBF4E5",
        8: "#DBF4E5",
        9: "#E2F1FF",
        10: "#BE8E12",
        11: "#DCDEE9",
        12: "#DCDEE9",
        13: "#DCDEE9",
        14: "#BE8E12",
    };

    const statusColor = (idStatus: number): string => {
        return statusColors[idStatus] || "rgb(226, 230, 243)";
    };

    const colorArray: Record<number, string> = {
        1: "#FFFFFF",
        2: "#8F6C10",
        3: "#8F6C10",
        4: "#FFFFFF",
        5: "#2B304F",
        6: "#AF4848",
        7: "#296B44",
        8: "#296B44",
        9: "#0975D9",
        10: "#FFFFFF",
        11: "#2B304F",
        12: "#2B304F",
        13: "#2B304F",
        14: "#FFFFFF",
    };

    const fontColor = (idStatus: number): string => {
        return colorArray[idStatus] || "#2B304F";
    };

    // const fontColor = (idStatus: number) => {
    //     switch (idStatus) {
    //         case 1: return "#FFFFFF";
    //         case 2: return "#8F6C10";
    //         case 3: return "#8F6C10";
    //         case 4: return "#FFFFFF";
    //         case 5: return "#2B304F";
    //         case 6: return "#AF4848";
    //         case 7: return "#296B44";
    //         case 8: return "#296B44";
    //         case 9: return "#0975D9";
    //         case 10: return "#FFFFFF";
    //         case 11: return "#2B304F";
    //         case 12: return "#2B304F";
    //         case 13: return "#2B304F";
    //         case 14: return "#FFFFFF";

    //         default: return "#2B304F";
    //     }
    // }

    const workStatusColors: Record<number, string> = {
        1: "#0975D9",
        2: "#FCEBC1",
        3: "#FCEBC1",
        5: "#DCDEE9",
        6: "#F9D0D0",
        7: "#DBF4E5",
        8: "#DBF4E5",
        11: "#DCDEE9",
        12: "#DCDEE9",
        13: "#DCDEE9",
        14: "#BE8E12",
        15: "#4DC77E",
        16: "#D35555",
      };

      const workStatusColor = (idStatus: number): string => {
        idStatus = (idStatus === 0) ? 1 : idStatus;
      
        return workStatusColors[idStatus] || "rgb(226, 230, 243)";
      };

    // const workStatusColor = (idStatus: number) => {
    //     idStatus = (idStatus === 0) ? 1 : idStatus;

    //     switch (idStatus) {
    //         case 1: return "#0975D9";
    //         case 2: return "#FCEBC1";
    //         case 3: return "#FCEBC1";
    //         case 5: return "#DCDEE9";
    //         case 6: return "#F9D0D0";
    //         case 7: return "#DBF4E5";
    //         case 8: return "#DBF4E5";
    //         case 11: return "#DCDEE9";
    //         case 12: return "#DCDEE9";
    //         case 13: return "#DCDEE9";
    //         case 14: return "#BE8E12";
    //         case 15: return "#4DC77E";
    //         case 16: return "#D35555";

    //         default: return "rgb(226, 230, 243)";
    //     }
    // }

    const workFontColors: Record<number, string> = {
        0: "#2B304F",
        1: "#FFFFFF",
        2: "#8F6C10",
        3: "#8F6C10",
        5: "#2B304F",
        6: "#AF4848",
        7: "#296B44",
        8: "#296B44",
        11: "#2B304F",
        12: "#2B304F",
        13: "#2B304F",
        14: "#FFFFFF",
        15: "#FFFFFF",
        16: "#FFFFFF",
    };
    
    const workFontColor = (idStatus: number): string => {
        idStatus = idStatus === 0 ? 1 : idStatus;
        return workFontColors[idStatus] || "#2B304F";
    };

    // const workFontColor = (idStatus: number) => {
    //     idStatus = (idStatus === 0) ? 1 : idStatus;

    //     switch (idStatus) {
    //         case 1: return "#FFFFFF";
    //         case 2: return "#8F6C10";
    //         case 3: return "#8F6C10";
    //         case 5: return "#2B304F";
    //         case 6: return "#AF4848";
    //         case 7: return "#296B44";
    //         case 8: return "#296B44";
    //         case 11: return "#2B304F";
    //         case 12: return "#2B304F";
    //         case 13: return "#2B304F";
    //         case 14: return "#FFFFFF";
    //         case 15: return "#FFFFFF";
    //         case 16: return "#FFFFFF";

    //         default: return "#2B304F";
    //     }
    // }

    return (
        <div className={"divStatusColorDisplay"} style={{ backgroundColor: (props.type === "work") ? workStatusColor(statusIdLocal) : statusColor(statusIdLocal) }}>
            <span style={{ fontWeight: "700", color: (props.type === "work") ? workFontColor(statusIdLocal) : fontColor(statusIdLocal) }}>{label}</span>
        </div >
    )
};

export default StatusColorDisplay;